import { render, staticRenderFns } from "./DirectViewerHelpRDP.vue?vue&type=template&id=6dc27cae&scoped=true&"
import script from "./DirectViewerHelpRDP.vue?vue&type=script&lang=js&"
export * from "./DirectViewerHelpRDP.vue?vue&type=script&lang=js&"
import style0 from "./DirectViewerHelpRDP.vue?vue&type=style&index=0&id=6dc27cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc27cae",
  null
  
)

export default component.exports